export default __webpack_public_path__ + "static/media/diaphragm.1612370d.svg";